"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.removeClassNameForCell = exports.addClassNameForCell = exports.getTableClassName = void 0;

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
* Tencent is pleased to support the open source community by making SPA UI available.
* Copyright (C) 2019, a Tencent company. All rights reserved.
*/

/**
 * @fileoverview 与classname相关
 * @author kirkzheng
 */

/**
 * 获取表格的className
 * @private
 */
var getTableClassName = function getTableClassName() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var tableClassName = props.tableClassName,
      striped = props.striped,
      hover = props.hover,
      bordered = props.bordered,
      condensed = props.condensed,
      responsive = props.responsive;
  var result = '';
  result = (0, _classnames["default"])('table', tableClassName, {
    'table-striped': striped,
    'table-hover': hover,
    'table-bordered': bordered,
    'table-condensed': condensed,
    'table-responsive': responsive
  });
  return result;
}; // 给对应的列所有的单元格加上对应的classname


exports.getTableClassName = getTableClassName;

var addClassNameForCell = function addClassNameForCell(tableWrap, index) {
  var className = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var tr = [],
      td = [],
      i = 0,
      len = 0;

  if (tableWrap && className) {
    tr = tableWrap.getElementsByTagName('tr');
    len = tr.length;

    for (; i < len; i++) {
      if (tr[i]) {
        td = tr[i].getElementsByTagName('th');

        if (td.length < 1) {
          td = tr[i].getElementsByTagName('td');
        }

        if (td && td[index]) {
          td[index].className = td[index].className + ' ' + className;
        }
      }
    }
  }
}; // 给对应的列所有的单元格去除对应的classname


exports.addClassNameForCell = addClassNameForCell;

var removeClassNameForCell = function removeClassNameForCell(tableWrap, index) {
  var className = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  var removeClassName = function removeClassName() {
    var node = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var theClassName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var classNameArray = [],
        result = [];

    if (node && theClassName) {
      classNameArray = node.className.split(' ');
      classNameArray.map(function (item) {
        if (item !== theClassName) {
          result.push(item);
        }

        return item;
      });
      node.className = result.join(' ');
    }
  };

  var tr = [],
      td = [],
      i = 0,
      len = 0;

  if (tableWrap && className) {
    tr = tableWrap.getElementsByTagName('tr');
    len = tr.length;

    for (; i < len; i++) {
      if (tr[i]) {
        td = tr[i].getElementsByTagName('th');

        if (td.length < 1) {
          td = tr[i].getElementsByTagName('td');
        }

        if (td && td[index]) {
          removeClassName(td[index], className);
        }
      }
    }
  }
};

exports.removeClassNameForCell = removeClassNameForCell;
var _default = {
  getTableClassName: getTableClassName,
  addClassNameForCell: addClassNameForCell,
  removeClassNameForCell: removeClassNameForCell
};
exports["default"] = _default;